export const education = [
    {Value: 0, Text: 'No', Hint: `Education`},
    {Value: 1, Text: 'Primary', Hint: `Primary School, Elementary School`},
    {Value: 2, Text: 'Secondary', Hint: `Secondary School, High School`},
    {Value: 3, Text: 'Bachelor', Hint: `Bachelor's Degree`},
    {Value: 4, Text: 'Master', Hint: `Master's Degree`},
    {Value: 5, Text: 'PhD'}
]

export const productMainTypes = [
    { Value: 0, Text: `Product` },
    { Value: 1, Text: `Service` },
    { Value: 2, Text: `Software` },
    { Value: 3, Text: `Other`}
];


export const productSubTypes = [
    { Value: 0, Text: `SAAS` },
    { Value: 1, Text: `TODO` },
    { Value: 2, Text: `TODO` },
    { Value: 3, Text: `Other`}
];

export const targetGroups = [
    { Value: 0, Text: `B2B` },
    { Value: 1, Text: `B2C` }
]

export const seniority = [
    { Value: 0, Text: `Unpaid`, Hint:`volunteers, unemployed, retired` },
    { Value: 1, Text: `Training`, Hint:`interns, trainees, students` },
    { Value: 2, Text: `Entry`, Hint:`entry-level skills, no leadership role` },
    { Value: 3, Text: `Senior`, Hint:`expert skills, no leadership role` },
    { Value: 4, Text: `Manager`, Hint:`managing entry & senior employees` },
    { Value: 5, Text: `Director`, Hint:`managing other managers` },
    { Value: 6, Text: `VP/CxO`, Hint:`executive and top managers` },
    { Value: 7, Text: `Owner`, Hint:`owner or partner with full operational control` },
]
